import { render, staticRenderFns } from "./mould_product.vue?vue&type=template&id=0fedcc24&scoped=true&"
import script from "./mould_product.vue?vue&type=script&lang=js&"
export * from "./mould_product.vue?vue&type=script&lang=js&"
import style0 from "./mould_product.vue?vue&type=style&index=0&id=0fedcc24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedcc24",
  null
  
)

export default component.exports